import { Component, OnInit } from "@angular/core";
import { iM } from "@angular/core/src/render3";
import swal from "sweetalert2";
import { ServicesService } from "../services/services.service";
import { ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-generate-report-pdf",
  templateUrl: "./generate-report-pdf.component.html",
  styleUrls: ["./generate-report-pdf.component.css"],
})
export class GenerateReportPdfComponent implements OnInit {
  data: any = {};
  QandAArray: any[] = [];
  public routePath;
  addMaintenanceOrderForm: any;
  showloader: boolean;
  isFormSubmitted: boolean;

  constructor(private _services: ServicesService) {}

  ngOnInit(): void {
    // Retrieve 'projectData' from local storage
    const projectDataString = localStorage.getItem("selectedMaintenanceData");

    if (projectDataString) {
      // Parse 'projectData' string to an object
      this.data = JSON.parse(projectDataString);

      console.log("Correct data:", this.data);
    }

    if (this.data && this.data.QandA) {
      this.QandAArray = JSON.parse(this.data.QandA);
      console.log("Questions:", this.QandAArray);
      
    }

  }
  resetProjectOrderForm() {
    throw new Error("Method not implemented.");
  }
}
